<script lang="ts">
    export let width: number;
    export let height: number;
    // width="28" height="100"
</script>

<svg {width} {height} viewBox="0 0 28 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line
        x1="14"
        y1="61.1729"
        x2="14"
        y2="2"
        stroke="url(#paint0_linear_370_17268)"
        stroke-width="4"
        stroke-linecap="round"
        stroke-dasharray="0.1 12"
    />
    <circle cx="14" cy="85.5846" r="6" fill="#327de3" />
    <rect x="0.5" y="72.0846" width="27" height="27" rx="13.5" stroke="#327de3" />
    <defs>
        <linearGradient
            id="paint0_linear_370_17268"
            x1="16"
            y1="0"
            x2="16"
            y2="63.1729"
            gradientUnits="userSpaceOnUse"
        >
            <stop stop-color="#327de3" stop-opacity="0" />
            <stop offset="1" stop-color="#327de3" />
        </linearGradient>
    </defs>
</svg>
